








































































































import { Vue, Component } from "vue-property-decorator";
import * as Type from "@/types";
import hubAppDefaults from "@/assets/constants/defaultSettings.json";
import RequestHandler from "@/assets/ts/requestHandler.ts";
const requestHandler = new RequestHandler();

@Component
export default class Login extends Vue {
  private isLoading = false;
  private showPassword = false;
  private validLoginFields = true;
  private credentialError = false;
  private serverError = false;
  private authError = false;
  backgroundImage = {
    "background-image":
      "url(" + require("@/assets/images/loginBackground.jpg") + ")",
    "background-repeat": "no-repeat",
    "background-size": "cover"
  };
  hubAppLink = "";
  private hubAppConfig: any = Object.assign(
    {},
    hubAppDefaults,
    this.$store.getters["hubAppConfig"]
  );
  private user = "";
  private password = "";
  private formRules: Type.FormRules = {
    required: value => !!value || "This field is required."
  };

  private async validateCreds(
    username: string,
    password: string
  ): Promise<void> {
    this.isLoading = true;

    try {
      const response: any = await requestHandler.call({
        username: username,
        password: password,
        action: "login"
      });
      this.$store.dispatch("setUserInfo", response);
      this.$store.dispatch("setFields", []);
      const county: any = await requestHandler.call({
        countyID: this.$store.getters.userInfo.CountyID,
        action: "getCounty"
      });
      Object.assign(response, { CountyName: county.countyName });
      localStorage.setItem("userInfo", JSON.stringify(response));
      this.$router.push({ name: "Home" });
    } catch (e) {
      console.error(e);

      if (e.response === undefined) {
        this.serverError = true;
        setTimeout(() => {
          this.serverError = false;
        }, 3000);
        return;
      }

      switch (e.response.status) {
        case 401:
          this.authError = true;
          setTimeout(() => {
            this.authError = false;
          }, 3000);
          break;
        case 500:
          this.serverError = true;
          setTimeout(() => {
            this.serverError = false;
          }, 3000);
          break;
        default:
          this.credentialError = true;
          setTimeout(() => {
            this.credentialError = false;
          }, 3000);
          break;
      }
    } finally {
      this.isLoading = false;
    }

    await requestHandler.setHubConfigs();
    const payload: any = {};
    Object.keys(this.hubAppConfig).forEach(key => {
      if (key in hubAppDefaults) {
        payload[key] = this.hubAppConfig[key];
      }
    });

    payload.silentUpdate = true;
    payload.updateSchedule =
      (await requestHandler.getConfig()).config.hubAppUpdateSchedule ??
      "0 3 * * *";

    try {
      await requestHandler.storeHubAppSettings(payload);
    } catch (e) {
      this.$root.$emit("snackbar-message", {
        text: "Unable to save settings.",
        color: "red"
      });
      return;
    }
  }

  async beforeCreate() {
    this.hubAppLink =
      (await requestHandler.getConfig()).config.hubDownloadBaseLocation +
      "StarInstaller.exe";
    if (this.$store.getters.userInfo.api_token !== "") {
      try {
        await requestHandler.call({ action: "logout" });
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.dispatch("setDefaultState");
      }
    }
    if ("userInfo" in localStorage) localStorage.removeItem("userInfo");
    await requestHandler.setHubConfigs();
  }
}
